import { isMobileScreen } from '../../../../../../ui/src';
import { useState } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import ViewReceiptsModal from '../modals/ViewReceiptsModal';
import ViewReceiptsModalV2 from '../modals/modalsv2/ViewReceiptsModalV2';
import { FeatureType } from '@apply/constants';
import { DrawBudgetCategory } from '../functions';
import { useAuthentication } from '../../../../../../../apps/bfi-apply/src/app/Login/hooks/useAuthentication';

interface IReceiptButtonParameters {
    categories: DrawBudgetCategory[];
    isAdmin: boolean;
    applicationInsights: ApplicationInsights;
}
export const ReceiptButton = ({ categories, isAdmin, applicationInsights }: IReceiptButtonParameters): JSX.Element => {
    const [isReceiptModalOpen, set_isReceiptModalOpen] = useState<boolean>(false);

    const mobileScreen = isMobileScreen();

    //Used for Apply side only validation of a feature - Draws is a shared control
    const { isFeatureEnabled } = useAuthentication();

    const checkApplyV2Enabled = () => {
        if (isAdmin) {
            return false;
        } else {
            return isFeatureEnabled(FeatureType.ApplyV2);
        }
    };

    return (
        <>
            {!mobileScreen ? (
                <button
                    id='receiptButton'
                    className='button primary'
                    onClick={() => set_isReceiptModalOpen(true)}
                >
                    Receipts
                </button>
            ) : (
                <></>
            )}
            {checkApplyV2Enabled() ? (
                <ViewReceiptsModalV2
                    key='test'
                    categories={categories}
                    applicationInsights={applicationInsights}
                    isOpen={isReceiptModalOpen}
                    close={() => set_isReceiptModalOpen(false)}
                />
            ) : (
                <ViewReceiptsModal
                    key='test'
                    categories={categories}
                    applicationInsights={applicationInsights}
                    isOpen={isReceiptModalOpen}
                    close={() => set_isReceiptModalOpen(false)}
                />
            )}
        </>
    );
};
